import { ExtraOptions, RouterModule, Routes,PreloadAllModules } from '@angular/router';
import { NgModule } from '@angular/core';

export const routes: Routes = [
  {
    path: 'pages',
    loadChildren: () => import('./pages/pages.module')
      .then(m => m.PagesModule),
  },
  {
    path: 'login',
    loadChildren: () => import('./luancher/login/login.module')
      .then(m => m.LoginModule),
  },
    {
      path: '',
      redirectTo: 'login',
      pathMatch: 'full',
    }
];

const config: ExtraOptions = {
  useHash: true,
  preloadingStrategy: PreloadAllModules
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
